const TelegramIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="url(#paint0_linear_32231_37712)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.52782 9.89397C7.44302 8.62386 9.38695 7.78653 10.3596 7.38197C13.1367 6.22688 13.7138 6.02623 14.0899 6.0196C14.1726 6.01814 14.3576 6.03865 14.4774 6.13587C14.5785 6.21796 14.6064 6.32885 14.6197 6.40668C14.633 6.48451 14.6496 6.66181 14.6364 6.80034C14.4859 8.38158 13.8348 12.2188 13.5035 13.9898C13.3633 14.7392 13.0873 14.9905 12.8201 15.0151C12.2393 15.0685 11.7984 14.6313 11.2359 14.2626C10.3558 13.6857 9.85857 13.3265 9.00425 12.7635C8.01694 12.1129 8.65697 11.7553 9.21964 11.1709C9.36689 11.018 11.9256 8.69066 11.9751 8.47954C11.9813 8.45313 11.987 8.35471 11.9285 8.30274C11.8701 8.25077 11.7838 8.26854 11.7215 8.28267C11.6332 8.30271 10.2272 9.23203 7.50344 11.0706C7.10435 11.3447 6.74286 11.4782 6.41898 11.4712C6.06193 11.4635 5.37511 11.2693 4.86452 11.1034C4.23827 10.8998 3.74054 10.7922 3.78388 10.4465C3.80646 10.2664 4.05443 10.0822 4.52782 9.89397Z"
      fill="white"
    />
    <defs>
      <linearGradient id="paint0_linear_32231_37712" x1="10" y1="0" x2="10" y2="19.8517" gradientUnits="userSpaceOnUse">
        <stop stopColor="#2AABEE" />
        <stop offset="1" stopColor="#229ED9" />
      </linearGradient>
    </defs>
  </svg>
);

export default TelegramIcon;
